import { Action } from 'redux';
import { IContentAndLuidInfo } from '../../../ts/mappers/DatabaseAndTableMapper';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { SetExternalTags, SetTags } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SetTagsAction extends Action {
  content: IContentInfo[];
}

export function setTags(...content: IContentInfo[]): SetTagsAction {
  return {
    type: SetTags,
    content: content
  };
}

export const isSetTagsAction = isActionFactory<SetTagsAction>(SetTags);

export interface SetExternalContentTagsAction extends Action {
  item: IContentAndLuidInfo;
}

export function setExternalContentTagsAction(item: SetExternalContentTagsAction['item']): SetExternalContentTagsAction {
  return {
    type: SetExternalTags,
    item
  };
}
